import { defineStore } from "pinia"
import { ref, type Ref } from "vue"
import { AlertTypes, type IAlert } from "@/interfaces/component/alert.interface"
import { monkeyEvents } from "@/services/monkey-events-service"

export const useAlertStore = defineStore("alertStore", () => {
  const currentAlert: Ref<IAlert | null> = ref(null)
  const alertQueue: Ref<Array<IAlert>> = ref([])
  let currentTimeout: ReturnType<typeof setTimeout> | null = null

  const defaultAlertLifeTime = 5000

  function addAlert(alert: IAlert) {
    if (currentAlert.value) {
      alertQueue.value.push(alert)
    } else {
      displayAlert(alert)
    }
  }

  function displayAlert(alert: IAlert) {
    currentAlert.value = alert
    if (alert.type === AlertTypes.SUCCESS) monkeyEvents.emit("celebrate")
    else if (alert.type === AlertTypes.ERROR) monkeyEvents.emit("startle")
    const lifetime = currentAlert.value?.lifetime ?? defaultAlertLifeTime

    if (lifetime > 0) {
      currentTimeout = setTimeout(() => {
        displayNextAlert()
      }, lifetime)
    }
  }

  function displayNextAlert() {
    clearCurrentTimeout()

    const nextAlert = alertQueue.value.shift()
    if (nextAlert) {
      displayAlert(nextAlert)
    } else {
      currentAlert.value = null
    }
  }

  function clearCurrentTimeout() {
    if (currentTimeout) {
      clearTimeout(currentTimeout)
      currentTimeout = null
    }
  }

  return {
    currentAlert,
    addAlert,
    displayNextAlert
  }
})
